import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";

export interface CustomGetOrderApiParameter extends GetOrdersApiParameter {
    showQuotes?: string;
}

type HandlerType = Handler<CustomGetOrderApiParameter & UpdateSearchFieldsType>;
export const DispatchUpdateSearchFields: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderHistory/UpdateSearchFields",
        parameter: props.parameter,
    });
};
export const chain = [DispatchUpdateSearchFields];
const updateSearchFieldsCustom = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateSearchFields");
export default updateSearchFieldsCustom;
